module.exports = __webpack_public_path__ + "img/body-boxes-signs.e9c7b8ad.png";